import dayjs from 'dayjs';

export const getUsFormattedDate = (date: string | Date): string => {
  return dayjs(date).format('MM-DD-YYYY');
}

export const getDateFromUSFormatted = (dateString: string): Date => {
  const [mm, dd, yyyy] = dateString.split('-').map(Number);
  return new Date(yyyy, mm - 1, dd);
}

export const getUTCDateFromUSFormatted = (dateString: string): Date => {
  const [mm, dd, yyyy] = dateString.split('-').map(Number);
  return new Date(Date.UTC(yyyy, (mm ?? 1) - 1, dd ?? 1));
}

export const getNearestMonday = (date: string | Date = new Date()): string => {
  const inputDate = dayjs(date);
  const dayOfWeek = inputDate.day();
  let daysToMonday: number;
  // If day is Friday, Saturday or Monday , roll forward to next monday
  if (dayOfWeek === 5) {
    daysToMonday = 3;
  } else if (dayOfWeek === 6) {
    daysToMonday = 2;
  } else if (dayOfWeek === 0) {
    daysToMonday = 1;
  } else {
    daysToMonday = dayOfWeek === 1 ? 0 : 1 - dayOfWeek;
  }
  const nearestMonday = new Date(inputDate.toDate());
  nearestMonday.setDate(inputDate.date() + daysToMonday);
  return getUsFormattedDate(nearestMonday);
};

// the logic is 7 days on from the nearest monday (UTC for consistent epoch values)
export const getForwardCalendarMonday = (): Date => {
  const forwardCalendarMonday = getUTCDateFromUSFormatted(getNearestMonday());
  forwardCalendarMonday.setUTCDate(forwardCalendarMonday.getUTCDate() + 7);
  return forwardCalendarMonday;
}

export const getNextMonday = (dateStr: string): string => {
  const date = getDateFromUSFormatted(dateStr);
  const dayOfWeek = date.getDay();
  const daysToNextMonday = (dayOfWeek === 0) ? 1 : (8 - dayOfWeek);
  date.setDate(date.getDate() + daysToNextMonday);
  return getUsFormattedDate(date);
}

export const getPreviousMonday = (dateStr: string): string => {
  const date = getDateFromUSFormatted(dateStr);
  const dayOfWeek = date.getDay();
  const daysToPrevMonday = dayOfWeek === 1 ? 7 : (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
  date.setDate(date.getDate() - daysToPrevMonday);
  return getUsFormattedDate(date);
}
